import './item-search-result-card.scss'

import { defineComponent, PropType } from 'vue';

import { SearchResult } from '@skinsoft/types';

import { searchResultSelectors } from '@skinsoft/search-data-store';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { BasicItemCard } from '../basic-item-card';
import { LocalizedString } from '@skinsoft/ui';

export const ItemSearchResultCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sLocalizedString: LocalizedString,
        sBasicItemCard: BasicItemCard,
    },
    props: {
        item: {
            type: Object as PropType<SearchResult>,
            required: true,
        },
    },
    template: require('./item-search-result-card.html'),
    computed: {
        title(): string {
            return searchResultSelectors.title(this.item, this.getAppLocale()) ?? ""
        },
    },
})
